export default __webpack_public_path__ + "static/logo_square-f481a2e52490e22dfebe1b5bc0fa1d36.jpg";